<template>
  <div>
    <v-list
      subheader
      three-line
      class="bg-transparent"
      v-if="taskList && taskList.length > 0"
    >
      <v-list-item-group
        v-model="selected"
        active-class="pink--text"
        multiple
      >
        <div
          v-for="(task, index) in taskList"
          :key="index"
        >
          <v-list-item 
            :value="task.taskId" 
            @click="selectTask(task)"
          >
            <template v-slot:prepend="{ isActive }">
              <v-list-item-action start>
                <v-icon
                  color="#E74343"
                  style="margin-left: 20px;"
                  :model-value="isActive"
                  size="x-large"
                >
                  mdi-radiobox-marked</v-icon
                >
              </v-list-item-action>
            </template>

            <v-list-item-content>
              <v-row align="center" class="spacer">
                <v-col cols="12" md="12" sm="12">
                  <v-list-item-title class="text-h6 text-wrap">
                    {{ task.taskTitle }}
                  </v-list-item-title>

                  <v-list-item-subtitle class="text-wrap">
                    Due on {{ formatDate(task.taskDueDate) }}
                  </v-list-item-subtitle>

                  <v-list-item-subtitle class="text-wrap">
                    {{ task.companyName }}
                  </v-list-item-subtitle>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
          <v-divider
            v-if="index < taskList.length - 1"
            :key="index"
          ></v-divider>
        </div>
      </v-list-item-group>
    </v-list>

    <div style="width: 100%;" v-else>
      <div
        class="w-100 p-4 d-flex align-items-center justify-content-center"
        style="height: 64vh;"
      >
        <v-table 
          color="transparent"
          style="width: 1000px; background-color: transparent;"
        >
          <tbody>
            <tr>
              <td 
                colspan="5"
                class="text-center"
              >
                <span>
                  No Tasks Found
                </span>
              </td>
            </tr>
          </tbody>
        </v-table>
      </div>
    </div>
  </div>
</template>

<script>
var moment = require("moment");

export default {
  name: 'Tasks',

  props: {
    taskList: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    tasks: [],
    selected: [],
    moment: moment,
  }),

  methods: {
    formatDate(date) {
      return moment.unix(date).format("DD-MMM-YYYY");
    },

    selectTask(task) {
      this.$emit('open_task', task);
    },
  },
}
</script>